module.exports = __webpack_public_path__ + "static/media/cleaningppl.7eab0a53.png";